import styled from 'styled-components'
import { P } from '../StyledText'
import { colors } from '../../styles'

export const StyledControlledInfiniteScroll = styled.div`
  overflow-y: auto;
  height: 90%;
` as React.ComponentType<any>

export const StyledNoResults = styled(P)`
  padding: 20px;
  color: ${colors.grey40};
`
